import { render } from "./ToggleEntityArchive.vue?vue&type=template&id=4c20792e&scoped=true&ts=true&lang=pug"
import script from "./ToggleEntityArchive.vue?vue&type=script&lang=ts"
export * from "./ToggleEntityArchive.vue?vue&type=script&lang=ts"

import "./ToggleEntityArchive.vue?vue&type=style&index=0&id=4c20792e&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c20792e"]])

export default __exports__